import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Card, CardHeader,CardContent,CardActions,
  Paper, Typography, 
} from '@mui/material';


import { Routes, Route, Navigate, useLocation, useParams, useNavigate } from "react-router-dom";
//import Box from '@mui/material/Box';

import {usePlayContext} from '../utils/PlayContext';

import {  
          fetchApplication,
          selectAllApplications, 
          fetchAllApplications,
          updateApplication,
          
          cancelApplication,

          selectApplicationById,
          selectApplicationStatus,
          selectApplicationError} from '../store/applicationSlice' 
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
//import PersonIcon from '@mui/icons-material/Person';


import GroupIcon from '@mui/icons-material/Group';

import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Tty';
import CompanyIcon from '@mui/icons-material/Business';




const InvitationDetailView = ({it})=>
{
    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo
    }=usePlayContext()

    let icon = it.type==='GROUP' ? <GroupIcon fontSize='inherit' /> :<PersonIcon fontSize='inherit' />
    
    let type = 'info'



    let listData=it.invitationVisitors;

    const navigate = useNavigate();

    if ('PENDING_PROFILE'===it.status) type='success'
    else if ('EXPIRED'===it.status) type='error'
    else type='info'


    const doEdit = ()=>{

    }


    const doReInvite = ()=>{
        navigate('/invitations/reinvite/'+it.id)

    }

    return(
      <Card variant="outlined">
        <CardHeader 
            sx={{my:0, mx:1, px:1}}
            title={<Typography variant='h6'>{it.reason}</Typography>}
            subheader={<Typography variant='body2'>{it.reoccurenceMessage}</Typography>}
            />

        <CardContent sx={{m:1,p:0, border:0}}>
        <Grid container columns={12}>
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Start Date Time :&nbsp;</strong>{it.startTm}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>End Date Time :&nbsp;</strong>{it.endTm ? it.endTm:'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Floor :&nbsp;</strong>{it.floor}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Host :&nbsp;</strong>{it.host}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Remarks :&nbsp;</strong>{it.remarks}
              </Typography>
            </Grid>
            
          
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Type :&nbsp;</strong>{it.type}
              </Typography>
            </Grid>
            {
                ('GROUP'===it.type) &&
                <>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant='body1'
                      ><strong>Max Person No. :&nbsp;</strong>{it.groupMaxPerson}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant='body1'
                      ><strong>Group Email :&nbsp;</strong>{it.groupSendToEmail}
                    </Typography>
                  </Grid>
              </>


            }
            <Grid item xs={12} md={6} lg={4}>
              <Typography variant='body1'
                ><strong>Status :&nbsp;</strong>{it.status}
              </Typography>
            </Grid>

          
          </Grid>

          <Grid container sx={{mt:1,p:1,border:0, borderColor:'#AAAAAA', borderRadius:1}} 
            columns={18}>
              <Grid item xs={18} 
                sx={{py:0,  mb:{xs:1, md:0}, }} >
                    <Typography  variant="subtitle1"  sx={{mr:'auto', ml: {sm:1, xs:0}}}>
                        <strong>Visitors</strong>
                    </Typography>
              </Grid>
          </Grid>

          <Grid container sx={{
              display:{xs:'none', md:'flex'},
              py:1, mt:0,border:1, borderColor:'#AAAAAA', borderRadius:1}} 
              columns={18}>
          
              <Grid item xs={18} md={4} 
                  sx={{mx:1, }}>
                    <Typography  variant="body2"  
                          sx={{fontWeight:550, ml:1}}>
                      Name
                    </Typography>
              </Grid>
              <Grid item xs={18} md={3} 
                          sx={{mx:1, }}>
                      <Typography  variant="body2"  
                      sx={{fontWeight:550, ml:1}}>
                        Phone Number
                      </Typography>
                  
              </Grid>
              <Grid item xs={18} md={5} 
                  sx={{mx:1, }}>
                    
                        <Typography  variant="body2"  
                        
                        sx={{fontWeight:550, ml:1}}>
                          Email
                        </Typography>
              </Grid>
              <Grid item xs={18} md={5} 
                  sx={{ mx:1, }}>
                    
                        <Typography  variant="body2"  
                          
                          sx={{fontWeight:550, ml:1}}>
                          Organization
                        </Typography>
                    
                </Grid>
                {/** 
                <Grid item xs={18} md={2} sx={{}}>
                  <Typography  variant="body2"
                    textAlign={'center'}
                        sx={{fontWeight:550,}}>
                          Status
                        </Typography>
                  
                </Grid>
                */}
          </Grid>

          {
              listData && listData.map(  
                (visitor, index)=>
                  (
                  <Grid  container key={visitor.id}
                          columns={18}
                          sx={{py:1, 
                          mb:{xs:1, md:0},
                          px:{xs:1, md:0},
                          border:{xs:1,md:0},
                          borderColor:'#aaaaaa',
                          borderRadius:1,
                          bgcolor:`${(index%2)===0 ? "#EAF2F8":"#E9F7EF"}`}}>

                  <Grid item xs={17} md={4} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        <Typography  variant="body2"  >
                        <PersonIcon size='small' color="primary"  sx={{mr:1, }}/>
                          {visitor.name}
                        </Typography>
                  </Grid>
                  <Grid item xs={17} md={3} 
                              sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                          <Typography  variant="body2"  >
                          <PhoneIcon size='small' color="primary"  sx={{mr:1, }}/>
                            {visitor.phoneDisplay}
                          </Typography>
                  </Grid>

                  <Grid item xs={17} md={5} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                            <Typography  variant="body2"  >
                            <EmailIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.email}
                            </Typography>
                  </Grid>
                  <Grid item xs={17} md={5} 
                      sx={{ mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        
                            <Typography  variant="body2"  >
                            <CompanyIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.company}
                            </Typography>
                        
                    </Grid>
                            
                </Grid>
                  )
              )
            }

          </CardContent>
          
          <CardActions sx={{ }}>
            
              <Box sx={{ display:'flex' , width:'100%', px:1, justifyContent:'space-around'}}>
                <Button variant="outlined" size='small'  sx={{display:'none'}}
					color='success'
                  onClick={doEdit}
                  //variant='contained'
                >Edit</Button>
                
                {/* <Button variant="outlined"size='small' 
                  
                     sx={{textTransform:'none', display:'block'}}

                  //variant='contained'
                  onClick={doReInvite}
                >Re-Invite</Button> */}

                {/* <Button variant="outlined"size='small'   color='error' 
                    sx={{textTransform:'none'}}
                    onClick={e=>{navigate('/invitations/delete/'+it.id)}}

                  >Delete
                </Button> */}

                
                { (it.status!=='EXPIRED'&&it.status!=='CANCELLED' &&it.status!=='ENROLED' &&
                    it.formattedEndTm > Date.now()
                
                    ) &&
                
                <>
                {/* <Button variant="outlined"size='small'   
						color='success' 
                      sx={{textTransform:'none'}}

                      onClick={e=>{navigate('/invitations/cancel/'+it.id)}}
                  >Cancel</Button> */}
                
                  <Button variant="outlined"size='small'   color='success' 
                      sx={{textTransform:'none'}}
                      onClick={e=>{navigate('/invitations/reschedule/'+it.id)}}
                  >Re-Schedule</Button>
                </>
                
                }

                
                <Button variant="outlined" sx={{textTransform:'none'}}
                  size='small'  
                    onClick={()=>navigate(-1)}
                  >Back</Button>
                </Box>
          </CardActions>
          
       </Card>
  );

}

const ApplyViewPage = () => {

    const {id}=useParams();

    const dispatch = useDispatch()

    const invitation = useSelector(selectApplicationById(id))

    const doFetchApplications= async(id)=>{
      setStatus('loading')
      try
      {
        //alert(123)
        let x = await dispatch(fetchApplication(id)).unwrap()
        setStatus('idle')
      }
      catch (ex)
      {
        setStatus('error')
        setErrorMessage("Fetch error")
      }
    }


    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      openSnackToast,

    }=usePlayContext()

    
    
    useEffect(() =>{
      setAppTitle( ['Invitations', 'View Details', invitation.reason+ " (ref#-"+invitation.id+")"])
      setErrorMessage('')
      setErrorTitle('')
      setOp('')
      
      
      doFetchApplications(id)
          return ()=>{
            setErrorMessage('')
            setErrorTitle('')
            setOp('')
          }

      }, [ ])
  

              

  return (
    <Box sx={{ p:1, width:'100%' }}>
       
         {
            invitation &&
      <InvitationDetailView  it={invitation}/>
          
        }
      
      
    </Box>
  );
};

export default ApplyViewPage;
